import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import CredentialCardSet from '@nmx/template/dist/componentLibrary/modules/CredentialCardSet';
// NM 2024 theme
import Nm2024Theme from '../../nm2024Theme/colors';

// eslint-disable-next-line import/prefer-default-export
export const CredentialCardSetNm2024 = styled(CredentialCardSet)`
  ${({ backgroundVariant, cardBgColor }) => {
    // NOTE: this cardBgColor prop is temporary for the Home Page experiment so we can swap between control and variant styles
    let thisBackgroundColor = cardBgColor || Nm2024Theme.sky.sky80;
    let thisTextColor = Nm2024Theme.navy.navy;

    if(backgroundVariant === 'darkDefault'){
      thisBackgroundColor = Nm2024Theme.navy.navy;
      thisTextColor = Nm2024Theme.neutral.white;
    }

    return css`
      &&& {
        .nmx-credential-card {
          background-color: ${thisBackgroundColor};
        }
        .nmx-credential-card-heading {
          color: ${thisTextColor};
          font-family: 'NM Serif', Georgia, 'Times New Roman', Times, serif;
        }
        .nmx-credential-card-description {
          color: ${thisTextColor};
          font-family: 'Source Sans', 'Helvetica Neue', Helvetica, sans-serif;
          letter-spacing: ${rem(0.5)};
        }
      }
    `;
  }
}`;
